
















































import Vue from 'vue'
import { DxColumn, DxDataGrid, DxEditing, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import { ProjectBookingMengen } from '@/model/project/ProjectBookingMengen'
import { hexToRgba } from '@/services/hex-to-rgba'

interface ComponentData {
  field1: string
  field2: string
  field2List: any[]
  field3: boolean
  field4: boolean
  field5: string
  field5List: any[]
  field6: boolean
}

export default Vue.extend({
  name: 'BookingAssistant2',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection,
    DxEditing
  },

  props: {
    step3Data: Array as () => ProjectBookingMengen[]
  },

  data (): ComponentData {
    return {
      field1: '',
      field2: '',
      field2List: [],
      field3: false,
      field4: false,
      field5: '',
      field5List: [],
      field6: false
    }
  },

  watch: {

  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {

  },

  mounted () {}
})
